export * from './text-area-auto-height-control.component';